import { ReactElement, memo } from 'react';
import { Collapse } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import classNames from 'classnames';

import { AssistantGenerateRoutesDialogCollapsableCardProps } from './types';
import {
  classes,
  AssistantGenerateRoutesDialogCollapsableCardContainer,
  AssistantGenerateRoutesDialogCollapsableCardContent,
  AssistantGenerateRoutesDialogCollapsableCardHeader,
  AssistantGenerateRoutesDialogCollapsableCardHeaderText,
} from './styles';

const AssistantGenerateRoutesDialogCollapsableCard = ({
  expanded,
  onExpanded,
  title,
  description,
  indicator,
  disabled = false,
  children,
}: AssistantGenerateRoutesDialogCollapsableCardProps): ReactElement => {
  return (
    <AssistantGenerateRoutesDialogCollapsableCardContainer variant="outlined">
      <AssistantGenerateRoutesDialogCollapsableCardContent>
        <AssistantGenerateRoutesDialogCollapsableCardHeader
          onClick={onExpanded}
          className={classNames({
            [classes.expanded]: expanded,
          })}
          disableRipple
          disableTouchRipple
          disabled={disabled}
        >
          <AssistantGenerateRoutesDialogCollapsableCardHeaderText
            primary={title}
            secondary={description}
          />

          {indicator}

          <KeyboardArrowDown className={classes.expandIcon} />
        </AssistantGenerateRoutesDialogCollapsableCardHeader>

        <Collapse
          in={expanded}
          timeout="auto"
          unmountOnExit
          sx={{ height: '100%' }}
        >
          {children}
        </Collapse>
      </AssistantGenerateRoutesDialogCollapsableCardContent>
    </AssistantGenerateRoutesDialogCollapsableCardContainer>
  );
};

export default memo(AssistantGenerateRoutesDialogCollapsableCard);
